module.exports = __webpack_public_path__ + "share-ok.9ae21957.png";